import { render, staticRenderFns } from "./Pares.vue?vue&type=template&id=1da328ec&"
import script from "./Pares.vue?vue&type=script&lang=js&"
export * from "./Pares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports